import { render } from "./background-image.vue?vue&type=template&id=41b42901&scoped=true&ts=true&lang=pug"
import script from "./background-image.vue?vue&type=script&setup=true&lang=ts"
export * from "./background-image.vue?vue&type=script&setup=true&lang=ts"

import "./background-image.vue?vue&type=style&index=0&id=41b42901&lang=stylus&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b42901"]])

export default __exports__